import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import RecaptchaComponent from './js/recaptcha.component';

ComponentsFactory.getInstance().define('recaptcha', RecaptchaComponent);
